// extracted by css-extract-rspack-plugin
export default {"pointer":"pointer-dgIbMf","message":"message-TIBP2c"};